import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-white">
      <div className="max-w-4xl mx-auto px-6 py-16">
        <h1 className="text-4xl font-bold text-gray-900 mb-8">Privacy Policy</h1>
        
        <div className="prose prose-lg max-w-none">
          <p className="text-gray-600 mb-6">
            <strong>Effective Date:</strong> October 2025
          </p>
          
          <p className="text-gray-700 mb-6">
            Kibouor Foundation respects your privacy. We collect only the information necessary to process donations, provide receipts, and keep you informed about our impact.
          </p>
          
          <p className="text-gray-700 mb-6">
            We do not sell, rent, or share your personal information with third parties.
            Your donations and data are securely stored, with all transactions recorded on Dot Protocol Blockchain for verification and transparency.
          </p>
          
          <p className="text-gray-700 mb-6">
            If you wish to update or delete your information, please email <a href="mailto:privacy@kibouor.org" className="text-blue-600 hover:underline">privacy@kibouor.org</a>.
          </p>
          
          <p className="text-gray-700 mb-6">
            By using our website, you consent to this Privacy Policy.
            We may update this policy periodically, and changes will be posted here.
          </p>
        </div>
        
        <div className="mt-12 pt-8 border-t border-gray-200">
          <a href="/" className="text-blue-600 hover:underline">← Back to Home</a>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
